import type { AccountEntityExpandResponse } from "@/shared/generated/ExpHubApi";

export enum InvoiceEmailVariant {
  Pdf = "PDF", // This is only used for showing the variant of existing emails, it is not available for creating new emails
  BisUbl = "BIS_UBL",
  FactureX = "FACTUREX",
  ZugferdExtended = "ZUGFERD_EXTENDED",
  ZugferdComfort = "ZUGFERD_COMFORT",
  XRechnungPeppol = "XRECHNUNGCII_PEPPOL",
  XRechnungEmail = "XRECHNUNGCII_EMAIL",
  BisUblMail = "BIS_UBL_MAIL",
}

export const mapToInvoiceEmailVariant = (
  data: NonNullable<
    AccountEntityExpandResponse["contactAddresses"]
  >[number]["kind"],
): InvoiceEmailVariant | undefined => {
  if (Object.values(InvoiceEmailVariant).includes(data as InvoiceEmailVariant))
    return data as InvoiceEmailVariant;

  return undefined;
};
